import DomComponent from '../../../app/lib/domComponent';

/**
 * The form component is used by all Formulate forms on the site. Its primary purpose is to manage
 * hiding and showing elements on form submission (e.g., failure content, success content, the form itself).
 */
export default class FormComponent extends DomComponent {
    static selector = '[data-js-form]';

    // The main DOM element that wraps the others.
    el;

    // The DOM element for the failure content.
    elFailure;

    // The DOM element for the success content.
    elSuccess;

    // The DOM element for the form content.
    elForm;

    /**
     * The constructor for this form component.
     * @param el The main wrapper DOM element.
     */
    constructor(el) {
        super(el);
        this.findElements(el);
        this.configureEventHandlers();
    }

    /**
     * Finds the DOM elements and stores them to member variables.
     * @param el The main wrapper DOM element.
     */
    findElements(el) {
        this.el = el;
        this.elForm = el.querySelector('[data-js-form-form-content]');
        this.elSuccess = el.querySelector('[data-js-form-success-content]');
        this.elFailure= el.querySelector('[data-js-form-failure-content]');
    }

    /**
     * Configures the event handlers for Formulate events.
     */
    configureEventHandlers() {
        this.el.addEventListener('formulate form: submit: success', this.handleFormSubmit.bind(this));
        this.el.addEventListener('formulate form: submit: failure', this.handleFormError.bind(this));
    }

    /**
     * Handles successful form submissions.
     */
    handleFormSubmit() {

        // Remove the form now that it's been submitted.
        this.elForm.parentNode.removeChild(this.elForm);

        // Remove the failure content (if there was an error, it no longer applies).
        if (this.elFailure) {
            this.elFailure.parentNode.removeChild(this.elFailure);
        }

        // Show the success content.
        if (this.elSuccess) {
            this.elSuccess.classList.remove('formulate-success-content--hidden');
            this.elSuccess.classList.add('formulate-success-content--visible');
        }

    }

    /**
     * Handles failed form submissions (e.g., if there was a server error).
     */
    handleFormError() {

        // Show the failure content.
        if (this.elFailure) {
            this.elFailure.classList.remove('formulate-failure-content--hidden');
            this.elFailure.classList.add('formulate-failure-content--visible');
        }

    }

}
